(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2478],{

/***/ 20655:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ DestinationPage; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(34727);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(97582);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _react_hook_window_size__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(61715);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _DestinationPage_module_scss__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(31558);
/* harmony import */ var _DestinationPage_module_scss__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(_DestinationPage_module_scss__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var _SearchBox_SearchBox__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var react_intersection_observer__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(70131);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _Lists_ReviewItem__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(74079);
/* harmony import */ var _utils_httpClient__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(22550);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _utils_replaceHTML__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(50549);
/* harmony import */ var html_react_parser__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(25935);
/* harmony import */ var _components_index__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(60306);
/* harmony import */ var _config_worldCountries__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(81140);

















var FeaturedContent = next_dynamic__WEBPACK_IMPORTED_MODULE_4___default()(function() {
    return __webpack_require__.e(/* import() */ 5808).then(__webpack_require__.bind(__webpack_require__, 5808));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(5808)
            ];
        }
    }
});
var RecommendationsList = next_dynamic__WEBPACK_IMPORTED_MODULE_4___default()(function() {
    return __webpack_require__.e(/* import() */ 9972).then(__webpack_require__.bind(__webpack_require__, 39972));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(39972)
            ];
        }
    }
});
var getHotel = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(function(country, city) {
        var hotelRes;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_11__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        (0,_utils_httpClient__WEBPACK_IMPORTED_MODULE_12__/* .httpGet */ .kA)("/api/destinations/hotels?country=".concat(country, "&city=").concat(city, "&sort=random&size=1"))
                    ];
                case 1:
                    hotelRes = _state.sent();
                    return [
                        4,
                        hotelRes.json()
                    ];
                case 2:
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    });
    return function getHotel(country, city) {
        return _ref.apply(this, arguments);
    };
}();
var DestinationPage = function(param) {
    var data = param.data;
    var getArticleLink = function getArticleLink(type, subtype, textId, country, city) {
        if (!type || !subtype || !textId) {
            return null;
        }
        if (type === "Hotels" && subtype === "Reviews") {
            type = "hotel";
            subtype = "review";
        }
        if (country) {
            return "/destinations/".concat(country, "/").concat(city ? city : textId);
        }
        return "/" + type.toLowerCase() + "/" + subtype.toLowerCase() + "/" + textId;
    };
    var getFlag = function getFlag(countryCode) {
        var flag = _config_worldCountries__WEBPACK_IMPORTED_MODULE_9__/* .WORLD_COUNTRIES.find */ .C.find(function(item) {
            return item.code === countryCode;
        }).flags;
        if (flag) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                src: flag.svg || flag.png,
                alt: flag.alt
            });
        }
    };
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
    var ref8 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(), facts = ref8[0], setFacts = ref8[1];
    var ref9 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(null), hotel = ref9[0], setHotel = ref9[1];
    var ref10 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(null), seoSchema = ref10[0], setSeoSchema = ref10[1];
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(function() {
        if (!facts) {
            setFacts(JSON.parse(data.destination.destSection));
        }
        if (!seoSchema) {
            var ref;
            if ((ref = data.destination.contentMetaData) === null || ref === void 0 ? void 0 : ref.seoSchema) {
                var ref1;
                setSeoSchema((0,html_react_parser__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP)((ref1 = data.destination) === null || ref1 === void 0 ? void 0 : ref1.contentMetaData.seoSchema));
            }
        }
    }, [
        data
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(function() {
        if (data && !hotel) {
            var fetchHotel = function() {
                var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(function() {
                    var ref, hotel;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_11__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    getHotel(data.destination.countrySafename, data.destination.citySafename)
                                ];
                            case 1:
                                hotel = _state.sent();
                                setHotel(((ref = hotel.content) === null || ref === void 0 ? void 0 : ref[0]) || null);
                                return [
                                    2
                                ];
                        }
                    });
                });
                return function fetchHotel() {
                    return _ref.apply(this, arguments);
                };
            }();
            fetchHotel().catch(console.error);
        }
    }, []);
    var width = (0,_react_hook_window_size__WEBPACK_IMPORTED_MODULE_13__/* .useWindowWidth */ .Lm)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_6___default()), {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                        children: ((ref = data.destination.contentMetaData) === null || ref === void 0 ? void 0 : ref.metaTitle) || "".concat(data.destination.city === "-" ? data.destination.country : data.destination.city, " - First-Class.com")
                    }),
                    ((ref1 = data.destination.contentMetaData) === null || ref1 === void 0 ? void 0 : ref1.seoHtml) === "true" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "robots",
                        content: "noindex, nofollow"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                        rel: "canonical",
                        href: "https://www.first-class.com" + ((ref2 = data.destination.contentMetaData) === null || ref2 === void 0 ? void 0 : ref2.canonicalTag)
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "description",
                        content: ((ref3 = data.destination.contentMetaData) === null || ref3 === void 0 ? void 0 : ref3.metaDescription) || (0,_utils_replaceHTML__WEBPACK_IMPORTED_MODULE_14__/* .replaceHTML */ .m)(data.destination.subHeading)
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:card",
                        content: "summary"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:site",
                        content: "first-class.com"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:title",
                        content: ((ref4 = data.destination.contentMetaData) === null || ref4 === void 0 ? void 0 : ref4.metaTitle) || "".concat(data.destination.city === "-" ? data.destination.country : data.destination.city, " - First-Class.com")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:description",
                        content: ((ref5 = data.destination.contentMetaData) === null || ref5 === void 0 ? void 0 : ref5.metaDescription) || (0,_utils_replaceHTML__WEBPACK_IMPORTED_MODULE_14__/* .replaceHTML */ .m)(data.destination.subHeading)
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:image",
                        content: "https://media.first-class.com/" + data.destination.frontImage.replace("/", "")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:title",
                        content: ((ref6 = data.destination.contentMetaData) === null || ref6 === void 0 ? void 0 : ref6.metaTitle) || "".concat(data.destination.city === "-" ? data.destination.country : data.destination.city, " - First-Class.com")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:type",
                        content: "article"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:image",
                        content: "https://media.first-class.com/" + data.destination.frontImage.replace("/", "")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:description",
                        content: ((ref7 = data.destination.contentMetaData) === null || ref7 === void 0 ? void 0 : ref7.metaDescription) || (0,_utils_replaceHTML__WEBPACK_IMPORTED_MODULE_14__/* .replaceHTML */ .m)(data.destination.subHeading)
                    }),
                    seoSchema
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "bg-review-bg",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_DestinationPage_module_scss__WEBPACK_IMPORTED_MODULE_15___default().topSection)),
                        children: [
                            data.destination.frontVideo && width >= 1024 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("video", {
                                src: "https://media.first-class.com/" + data.destination.frontVideo.replace("/", ""),
                                autoPlay: true,
                                muted: true,
                                loop: true
                            }),
                            (data.destination.frontImage && !data.destination.frontVideo || data.destination.frontImage && width < 1024) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                src: "https://media.first-class.com/" + data.destination.frontImage.replace("/", ""),
                                alt: "Destination - ".concat(data.destination.heading)
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_DestinationPage_module_scss__WEBPACK_IMPORTED_MODULE_15___default().topSectionText), "font-fragment"),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: (_DestinationPage_module_scss__WEBPACK_IMPORTED_MODULE_15___default().heading),
                                        children: data.destination.heading
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: (_DestinationPage_module_scss__WEBPACK_IMPORTED_MODULE_15___default().description),
                                        children: data.destination.subHeading
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_DestinationPage_module_scss__WEBPACK_IMPORTED_MODULE_15___default().content)),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_DestinationPage_module_scss__WEBPACK_IMPORTED_MODULE_15___default().topSectionSearch), "container mx-auto px-4"),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_SearchBox_SearchBox__WEBPACK_IMPORTED_MODULE_2__/* .SearchBox */ .R, {
                                    type: "mainSearch",
                                    activeTab: 0,
                                    searchSource: "Destination"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "container",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_DestinationPage_module_scss__WEBPACK_IMPORTED_MODULE_15___default().contentSearch), "mx-auto px-4"),
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_SearchBox_SearchBox__WEBPACK_IMPORTED_MODULE_2__/* .SearchBox */ .R, {
                                            type: "sideSearch",
                                            activeTab: 0,
                                            searchSource: "Destination"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_DestinationPage_module_scss__WEBPACK_IMPORTED_MODULE_15___default().introduction)),
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_index__WEBPACK_IMPORTED_MODULE_8__/* .BCBreadcrumbs */ .k7, {
                                                headerText: data.destination.heading
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                                                className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_DestinationPage_module_scss__WEBPACK_IMPORTED_MODULE_15___default().introductionHeading), "font-fragment"),
                                                children: data.destination.introTitle
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_DestinationPage_module_scss__WEBPACK_IMPORTED_MODULE_15___default().introductionDescription), "font-libre"),
                                                dangerouslySetInnerHTML: {
                                                    __html: data.destination.intro
                                                }
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: (_DestinationPage_module_scss__WEBPACK_IMPORTED_MODULE_15___default().carouselBack),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "container",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_intersection_observer__WEBPACK_IMPORTED_MODULE_16__/* .InView */ .df, {
                                        triggerOnce: true,
                                        children: function(param) {
                                            var inView = param.inView, ref = param.ref;
                                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                ref: ref,
                                                className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_DestinationPage_module_scss__WEBPACK_IMPORTED_MODULE_15___default().carouselWrapper), "w-full sm:px-4 mx-auto"),
                                                children: inView && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FeaturedContent, {
                                                    hideHeading: true,
                                                    items: data.destination.topLists,
                                                    enableInfinite: true,
                                                    executePaginate: false,
                                                    showThumbs: true
                                                })
                                            });
                                        }
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "container",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_DestinationPage_module_scss__WEBPACK_IMPORTED_MODULE_15___default().introduction)),
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_DestinationPage_module_scss__WEBPACK_IMPORTED_MODULE_15___default().introductionHeading), "font-fragment"),
                                                children: data.destination.flightSectionTitle
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_DestinationPage_module_scss__WEBPACK_IMPORTED_MODULE_15___default().introductionDescription), "font-libre"),
                                                dangerouslySetInnerHTML: {
                                                    __html: data.destination.flightSection
                                                }
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_DestinationPage_module_scss__WEBPACK_IMPORTED_MODULE_15___default().contentBoxes)),
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_DestinationPage_module_scss__WEBPACK_IMPORTED_MODULE_15___default().destination)),
                                                children: [
                                                    !!data.destination.guides.length && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_DestinationPage_module_scss__WEBPACK_IMPORTED_MODULE_15___default().destinationRecommendation)),
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(RecommendationsList, {
                                                            items: data.destination.guides,
                                                            hideHeading: true
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_DestinationPage_module_scss__WEBPACK_IMPORTED_MODULE_15___default().destinationFacts)),
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_DestinationPage_module_scss__WEBPACK_IMPORTED_MODULE_15___default().factsHeading), "font-fragment"),
                                                                children: [
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                        children: [
                                                                            data.destination.city === "-" ? data.destination.country : data.destination.city,
                                                                            " ",
                                                                            "Facts"
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_DestinationPage_module_scss__WEBPACK_IMPORTED_MODULE_15___default().factsFlag)),
                                                                        children: getFlag(data.destination.countryCode)
                                                                    })
                                                                ]
                                                            }),
                                                            !!(facts === null || facts === void 0 ? void 0 : facts.length) && facts.map(function(fact) {
                                                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                    className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_DestinationPage_module_scss__WEBPACK_IMPORTED_MODULE_15___default().fact), "font-libre"),
                                                                    children: [
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                            className: (_DestinationPage_module_scss__WEBPACK_IMPORTED_MODULE_15___default().factName),
                                                                            children: [
                                                                                fact.name,
                                                                                ":"
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                            className: (_DestinationPage_module_scss__WEBPACK_IMPORTED_MODULE_15___default().factDescription),
                                                                            children: fact.value
                                                                        })
                                                                    ]
                                                                }, fact.name);
                                                            })
                                                        ]
                                                    }),
                                                    !!data.destination.faqs.length && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        className: "flex justify-center my-10",
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_index__WEBPACK_IMPORTED_MODULE_8__/* .VintageButton */ .Fz, {
                                                            href: getArticleLink(data.destination.faqs[0].type, data.destination.faqs[0].subtype, data.destination.faqs[0].textId, data.destination.faqs[0].country, data.destination.faqs[0].city),
                                                            label: "".concat(data.city === "-" ? data.country : data.city, " Faq"),
                                                            target: "_blank",
                                                            dark: true
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_DestinationPage_module_scss__WEBPACK_IMPORTED_MODULE_15___default().hotel)),
                                                        children: [
                                                            !!hotel && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Lists_ReviewItem__WEBPACK_IMPORTED_MODULE_5__/* .ReviewItem */ .r, {
                                                                type: "Hotel",
                                                                starRating: true,
                                                                review: hotel,
                                                                url: "/hotel/review/".concat(hotel.textId)
                                                            }),
                                                            !hotel && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                className: "mx-auto mt-8",
                                                                children: "Please add hotel"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        className: "flex justify-center mb-2 mt-10",
                                                        children: !!hotel && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_index__WEBPACK_IMPORTED_MODULE_8__/* .VintageButton */ .Fz, {
                                                            href: "/destinations/".concat(data.destination.countrySafename, "/").concat(data.destination.citySafename, "/hotels"),
                                                            className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_DestinationPage_module_scss__WEBPACK_IMPORTED_MODULE_15___default().moreHotelsButton), "font-libre mx-auto"),
                                                            dark: true,
                                                            label: "More hotels in \n                      ".concat(data.destination.citySafename !== "-" ? data.destination.city : data.destination.country)
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};


/***/ }),

/***/ 50549:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "m": function() { return /* binding */ replaceHTML; }
/* harmony export */ });
var replaceHTML = function(string) {
    return string === null || string === void 0 ? void 0 : string.replace(/<[^>]*>?/gm, "");
};


/***/ }),

/***/ 31558:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"topSection":"DestinationPage_topSection__0lQXO","topSectionText":"DestinationPage_topSectionText__IaMpH","heading":"DestinationPage_heading__SsgqJ","description":"DestinationPage_description__8X1Pq","topSectionSearch":"DestinationPage_topSectionSearch____Uc8","content":"DestinationPage_content__bQpHo","introductionDescription":"DestinationPage_introductionDescription__hbM4_","carouselBack":"DestinationPage_carouselBack__S2KwB","contentSearch":"DestinationPage_contentSearch__EU6qV","introduction":"DestinationPage_introduction__JFare","introductionHeading":"DestinationPage_introductionHeading__9gSU6","contentBoxes":"DestinationPage_contentBoxes__zveT6","destination":"DestinationPage_destination__1_qhy","destinationFacts":"DestinationPage_destinationFacts__lmMj4","factsHeading":"DestinationPage_factsHeading__Ju0UT","factsFlag":"DestinationPage_factsFlag__NRtMa","fact":"DestinationPage_fact__1aUYh","factName":"DestinationPage_factName__5tog7","factDescription":"DestinationPage_factDescription__bhEQ9","hotel":"DestinationPage_hotel__m_ZYO","moreHotelsButton":"DestinationPage_moreHotelsButton___hj8r"};

/***/ })

}]);